export default "__VITE_ASSET__41592bc5__"